import { SIDEBAR_WIDTH } from 'nav-meta/constants';
import getHubspotPageElement from '../../../utils/getHubspotPageElement';
export const updatePageWidthForVerticalNav = ({
  isVerticalNavEnabled
}) => {
  const pageElement = getHubspotPageElement();
  if (!pageElement) return;
  if (isVerticalNavEnabled) {
    pageElement.style.width = `calc(100% - var(--global-nav-vertical-nav-width, ${SIDEBAR_WIDTH}))`;
    pageElement.style.marginLeft = 'auto';
    return;
  }
  pageElement.style.width = 'auto';
  pageElement.style.marginLeft = '0';
};